import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'CONTRATO_ITEM_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'CONTRATO_ITEM_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('contratoItemForm', registro)
    ];
}

export function getLista(id_contrato) {
	const request = axios.get(`${consts.API_URL}/contratoItem?id_contrato=${id_contrato || 0}`);
	return {
		type: 'CONTRATO_ITEM_LISTADO',
		payload: request
	};
}

export function salvar(registro, evento) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/contratoItem`, {
				...registro,
				valor: FormatUtils.formatarValorBanco(registro.valor, 2),
                valor_plantao: FormatUtils.formatarValorBanco(registro.valor_plantao, 2),
                percentual_imposto: FormatUtils.formatarValorBanco(registro.percentual_imposto, 2),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista(registro.id_contrato));
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/contratoItem`, {
				...registro,
				valor: FormatUtils.formatarValorBanco(registro.valor, 2),
                valor_plantao: FormatUtils.formatarValorBanco(registro.valor_plantao, 2),
                percentual_imposto: FormatUtils.formatarValorBanco(registro.percentual_imposto, 2),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista(registro.id_contrato));
				dispatch(setModoTela('lista'));				

				try {
					if (evento) {
						evento();
					}
				} catch(ex) {

				}
				
			}).catch(e => {
				console.log(e);
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/contratoItem?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista(registro.id_contrato));
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}